// src/components/mitchRoom/modelOutputs/FilterSelect.js
import React from 'react';
import { Label } from 'components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';

const ALL_VALUE = 'all';

/**
 * Labelled select over {id, label} options. IDs keep their original type via a
 * String() round-trip. Pass `allLabel` to prepend an "All" entry that maps to
 * null; omit it for a required selection.
 */
export default function FilterSelect({ label, allLabel, value, options, onChange, className }) {
  return (
    <div className="flex flex-col gap-1">
      <Label className="text-token-base font-normal text-muted-foreground">{label}</Label>
      <Select
        value={value != null ? String(value) : ALL_VALUE}
        onValueChange={(v) => {
          if (v === ALL_VALUE) {
            onChange(null);
            return;
          }
          const match = options.find((o) => String(o.id) === v);
          onChange(match ? match.id : v);
        }}
      >
        <SelectTrigger className={className || 'h-9 w-[200px]'}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {allLabel != null && <SelectItem value={ALL_VALUE}>{allLabel}</SelectItem>}
          {options.map((option) => (
            <SelectItem key={option.id} value={String(option.id)}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
